var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2153 15.8652C13.2153 13.065 13.2153 11.6648 13.7603 10.5953C14.2397 9.65446 15.0046 8.88956 15.9454 8.41021C17.0149 7.86523 18.4151 7.86523 21.2153 7.86523H40.2153C43.0156 7.86523 44.4158 7.86523 45.4853 8.41021C46.4261 8.88956 47.1911 9.65446 47.6703 10.5953C48.2153 11.6648 48.2153 13.065 48.2153 15.8652V52.8652L30.7153 40.3652L13.2153 52.8652V15.8652Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.3f5e865e8a3c24d233aa787eb33a429c.svg";
export { ForwardRef as ReactComponent };